import { Route } from '../../../core/utils/RouteMixins';
import Pages from '../../../config/Pages';
import Listagem from './AnaliseMetodologicaListagem';
import Form from './analiseMetodologicaForm/AnaliseMetodologicaForm';
import { permissionEnums } from '../../../core/enums/PermissionEnums';

const analiseMetodologicaRoutes = [
    Route(
        ['Análise Metodológica', 'pi pi-percentage'],
        Pages.sei.analiseMetodologica.url.list,
        Listagem,
        [permissionEnums.ANALISE_METODOLOGICA_VISUALIZAR]
    ),
    Route(null, Pages.sei.analiseMetodologica.url.edit, Form, [
        permissionEnums.ANALISE_METODOLOGICA_EDITAR,
    ]),
];

export default analiseMetodologicaRoutes;
